import { render, staticRenderFns } from "./loan-advance-filter.vue?vue&type=template&id=167b57ae"
import script from "./loan-advance-filter.vue?vue&type=script&lang=js"
export * from "./loan-advance-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports